import MailFooter       from "../../../../domain/mail/setting/MailFooter";
import MailReplyTo         from "../../../../domain/mail/setting/MailReplyTo";
import MailSetting      from "../../../../domain/mail/setting/MailSetting";
import ResKaReduxAction from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_MAIL_SETTING = "SET_MAIL_SETTING",
  SET_MAIL_SETTING_FROM = "SET_MAIL_SETTING_FROM",
  SET_MAIL_SETTING_FOOTER = "SET_MAIL_SETTING_FOOTER",
}

export interface SetMailSettingAction extends ResKaReduxAction {
  mailSetting: MailSetting;
}

export interface SetMailSettingReplyToAction extends ResKaReduxAction {
  mailReplyTo: MailReplyTo;
}

export interface SetMailSettingFooterAction extends ResKaReduxAction {
  mailFooter: MailFooter;
}

export type MailSettingAction = SetMailSettingAction | SetMailSettingReplyToAction | SetMailSettingFooterAction;

export const setMailSettingAction = (mailSetting: MailSetting): SetMailSettingAction => ({
  type: ACTION_TYPE.SET_MAIL_SETTING,
  mailSetting: mailSetting,
});

export const setMailSettingReplyToAction = (mailReplyTo: MailReplyTo): SetMailSettingReplyToAction => ({
  type: ACTION_TYPE.SET_MAIL_SETTING_FROM,
  mailReplyTo: mailReplyTo,
});

export const setMailSettingFooterAction = (mailFooter: MailFooter): SetMailSettingFooterAction => ({
  type: ACTION_TYPE.SET_MAIL_SETTING_FOOTER,
  mailFooter: mailFooter,
});